import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { BusinessAccountTypeNameMapping, BusinessAccountWithChildrenDto, ChildUserAccountDto } from 'src/app/core/dtos/dto';
import { BrandEnum } from 'src/app/core/dtos/enum';
import { BusinessAccountService } from 'src/app/core/services/business-account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { selectAuth } from 'src/app/state/auth.selectors';

@Component({
  selector: 'app-business-account-info',
  templateUrl: './business-account-info.component.html',
  styleUrls: ['./business-account-info.component.scss']
})
export class BusinessAccountInfoComponent implements OnInit, OnDestroy {

  @Input() businessAccount: BusinessAccountWithChildrenDto;
  @Input() businessAccountTypeNameMapping: BusinessAccountTypeNameMapping;
  @Input() brandId: BrandEnum;

  aliasChildTokenSubscription: Subscription;
  aliasChildAccount: ChildUserAccountDto;
  auth: AuthModel;
  batchRegistrationLink: string;
  brandName: string;

  constructor(
    private router: Router,
    private toastService: HotToastService,
    private loadingService: LoadingService,
    private businessAccountService: BusinessAccountService,
    private shoppingCartService: ShoppingCartService,
    private store: Store,
    private configHelper: ConfigHelper
  ) { }

  ngOnInit(): void {
    this.batchRegistrationLink = this.brandId === BrandEnum.CAEL ? '/batch-registration/sitting-selection' : '/batch-registration/test-selection';
    this.brandName = this.configHelper.getBrandName();
    this.store.select(selectAuth).pipe(take(1))
      .subscribe(result => {
        this.auth = result;
      });
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  configureNotifications(businessAccountTypeNameMapping) {
    const navigationExtras: NavigationExtras = {
      state: {
        typeNameMapping: businessAccountTypeNameMapping
      },
    };

    this.router.navigate(['account/configure-notifications'], navigationExtras);
  }

  aliasSignIn(childUserAccountId: number) {
    this.loadingService.show();
    this.aliasChildTokenSubscription = this.businessAccountService.getAliasChildAccountToken(childUserAccountId)
      .subscribe(
        (result) => {
          this.businessAccountService.setTokenAndRedirectForAliasChildAccount(result.content.token, result.content.email, this.auth);
          this.shoppingCartService.getShoppingCart();
          this.loadingService.hide();
        },
        (error) => {
          this.loadingService.hide();
          let errorMsg = "Alias Sign-in failed.";
          if (error && error.error_description) {
            errorMsg = error.error_description;
          }
          this.toastService.warning(errorMsg);
        }
      );
  }

  ngOnDestroy(): void {
    this.aliasChildTokenSubscription?.unsubscribe();
  }

}
